import { Shield, FileCheck, Clock, Award } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const badges = [
  { icon: FileCheck, label: "Free Estimates" },
  { icon: Shield, label: "Fully Insured" },
  { icon: Clock, label: "On Time Scheduling" },
  { icon: Award, label: "Quality Craftsmanship" },
];

const TrustBadges = () => {
  return (
    <section className="bg-muted py-6 border-y border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8">
          {badges.map((badge) => (
            <div
              key={badge.label}
              className="flex items-center gap-2 text-foreground"
            >
              <badge.icon className="h-5 w-5 text-primary" />
              <span className="font-heading font-semibold text-sm md:text-base uppercase tracking-wide">
                {badge.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
